/**
 * Pads an Aff (affiliate) value to 3 digits with leading zeros if necessary.
 * Returns the original value if it's already 3+ characters or not a valid numeric string.
 *
 * This function is intentionally kept in a separate file with no external dependencies
 * to avoid circular dependency issues when used in Redux reducers.
 *
 * @param aff - The affiliate value to pad
 * @returns The padded affiliate value (e.g., "10" -> "010", "010" -> "010", "1" -> "001")
 *
 * @example
 * padAff("10")   // returns "010"
 * padAff("010")  // returns "010"
 * padAff("1")    // returns "001"
 * padAff("123")  // returns "123"
 * padAff("")     // returns ""
 * padAff("abc")  // returns "abc" (non-numeric, returned as-is)
 */
export function padAff(aff: string | undefined | null): string {
  if (!aff) {
    return aff ?? "";
  }

  // If already 3+ characters, return as-is
  if (aff.length >= 3) {
    return aff;
  }

  // Only pad if it's a numeric string
  if (/^\d+$/.test(aff)) {
    return aff.padStart(3, "0");
  }

  // Non-numeric strings are returned as-is
  return aff;
}
